export const baseUri = `:apiUri/transactions`;
export const baseMoveUri = `:apiUri/moves/:id`;
export const baseUriAssetUpload = `${baseMoveUri}/energy/meter-reading-assets`;
